<template>
  <div class="home-page" style="padding-top: 0;">
    <div class="login-content">
      <div class="login login-send">
        <div class="">
          <div class="home-prize">
            <div class="home1">
              <div class="pt20">
                <a class="logo" style="text-align: left;margin: 0 1rem -3rem;position: relative;">
                  <img src="static/images/logo.png"/></a>
              </div>
              <img  src="../../static/images/login-pic.png"/>
            </div>
          </div>
          <div class="input-div" >
            <div class="fs50 crfff mt30" style="width: 90%;margin:0 auto" v-html="$t('Login')"></div>
            <div class="span mt30 fs33 cr0062ff fw7" style="font-weight: 400;margin-bottom: 1rem;">
              {{ $t('loginTips') }}
            </div>
            <div class="input-item mt50">
              <div class="input-item2">
                <input class="input" disabled v-model="mobile" type="tel" maxlength="20" placeholder="">
              </div>
            </div>
          </div>
          <div class="ac mt50">
            <button class="button fw7" @click="goLogin">{{ $t('Login') }}</button>
          </div>
          <div class="ac otp-b disflex mt100">
            <div style="color: white" class="icon icon2" @click="getType('faq')">{{ $t('FAQ') }} <span
              class="app-en">>></span></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      mobile: '',
    }
  },
  created() {
    if (localStorage.getItem('lang')) this.isEN = localStorage.getItem('lang')
    if (this.$route.query.mobile) {
      this.mobile = this.$route.query.mobile
    }
  },
  methods: {
    getType(type) {
      this.$router.push({path: '/' + type, query: {type: type}});
    },
    back() {
      this.$router.go(-1);
    },

    goLogin() {
      let that = this
      if (that.mobile == '') {
        that.$utils.alertText(that.$t('loginTips'), 60)
        return;
      }
      let mobile = this.mobile
      let data = {
        'mobile': mobile,
      }
      that.$parent.loadModal(true);
      //检测号码
      that.$api.post('/api/user/real_check_user', data, r => {
        that.$parent.loadModal(false);
        if (r.code == 1) {
          localStorage.setItem('token', r.data.userinfo.token)
          localStorage.setItem('mobile', r.data.userinfo.mobile)
          that.isShowlogin = false
          that.mobile = ''
          that.$router.push({path: '/'})
        }else if (r.code == -2){
          const browserQuery = {}
          const searchParams = new URLSearchParams(window.location.search)
          searchParams.forEach((value, key) => {
            browserQuery[key] = value
          })
          that.$router.push({
            path: '/resub',
            query: Object.assign({}, browserQuery, this.$route.query, {mobile: mobile})
          })
        }else if (r.code == -1){
          const browserQuery = {}
          const searchParams = new URLSearchParams(window.location.search)
          searchParams.forEach((value, key) => {
            browserQuery[key] = value
          })
          that.$router.push({
            path: '/sub',
            query: Object.assign({}, browserQuery, this.$route.query, {mobile: mobile})
          })
        }
      })
    },
  }
}
</script>
<style scoped>
.home1 img {
  display: block;              /* 让 img 成为块级元素 */
  margin: 0 auto;              /* 水平居中 */
  max-width: 100%;             /* 防止溢出容器 */
}
.drop-down-content {
  z-index: 9;
  background: none;
}

.mt100 {
  margin-top: 100px;
}

.otp-b {
  justify-content: space-evenly;
}
</style>



// WEBPACK FOOTER //
// src/page/Login.vue